import React from "react";

const Loader = () => (
  <div className="loading">
    <div className="loader"></div>
  </div>
);

export default Loader;
